import { Outlet } from "react-router-dom";

import AppWrapper from "../../../../components/cm/AppWrapper";
import SideBarMain from "../../../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <div className="transparent mt-6 flex flex-1 flex-col overflow-y-auto rounded-b-[15px] rounded-t-lg bg-white xl:mr-6">
        <Outlet />
      </div>
    </AppWrapper.WithSidebar>
  );
};
